import { Box } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { theme } from 'theme';
import { CaseStatusType } from 'pco-product-service-internal-consumer';
import { formatEnum } from 'utils/stringUtils';
import { StepIcon, StyledStepConnector } from 'views/MemberZoneAccess/MemberZoneStatus/MemberCodeStatusStepper';

const styles = {
  root: {
    width: '60%',
  },
  stepper: {
    padding: theme.spacing(0),
    margin: theme.spacing(0),
  },
  step: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
  stepLabel: {
    alignItems: 'flex-start',
  },
  stepLabelText: {
    fontWeight: 600,
    marginTop: theme.spacing(-2),
  },
  textContainer: {
    textAlign: 'start',
  },
};

type Props = {
  activeStep: CaseStatusType;
  dates?: string[];
};

export default function CaseStatusStepper({ activeStep, dates = [] }: Props) {
  const StepLabels = Object.values(CaseStatusType);
  const activeStepToShow = Object.values(CaseStatusType).indexOf(activeStep);

  return (
    <Box data-testid="case-status-stepper" sx={styles.root}>
      <Stepper sx={styles.stepper} alternativeLabel activeStep={activeStepToShow} connector={<StyledStepConnector />}>
        {StepLabels.map((step, i) => {
          return (
            <Step key={`${step}-${i}`} disabled={false} sx={styles.step}>
              <StepLabel error={false} StepIconComponent={StepIcon} sx={styles.stepLabel}>
                <Box sx={styles.textContainer}>
                  <Typography variant={'body1'} sx={styles.stepLabelText}>
                    {formatEnum(step)}
                  </Typography>
                  <Typography variant={'caption'}>{dates[i] ? moment(dates[i]).format('DD.MM.YYYY') : ''}</Typography>
                </Box>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
